import React from 'react'
import makeStyles from '@mui/styles/makeStyles'

import MultipleQuestions from '~/components/dashboard/clients/timeline/question/MultipleQuestions'
import OneQuestion from '~/components/dashboard/clients/timeline/question/OneQuestion'
import type { QuestionTimelineItemEntry } from '~/types'

const useStyles = makeStyles(
  (theme) => ({
    questionRoot: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  }),
  { name: 'QuestionCard' },
)
const QuestionCardContent = ({
  entries,
  hasDifferedBusinessEntries,
}: {
  entries: QuestionTimelineItemEntry[]
  hasDifferedBusinessEntries: boolean
}) => {
  const classes = useStyles()
  const hasMultipleQuestions = entries.length > 1

  return (
    <>
      <OneQuestion
        classes={{ root: classes.questionRoot }}
        question={entries[0]}
        showAppointmentButton={hasMultipleQuestions}
      />
      {hasMultipleQuestions && (
        <MultipleQuestions
          enableBusinessShareIcon={hasDifferedBusinessEntries}
          questions={entries.slice(1)}
        />
      )}
    </>
  )
}

export default QuestionCardContent
